import React from "react";

const styles = {
  container: {
    backgroundColor: "green",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100vh",
    position: "absolute",
    top: 0,
    right: 0,
    zIndex: 10,
  } as const,
  h1: {
    color: "white",
  },
  h2: {
    color: "white",
  },
};

const GateOpenPerSchedule = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.h1}>Gate Unlocked</h1>
      <h2 style={styles.h2}>You can now enter</h2>
    </div>
  );
};

export default GateOpenPerSchedule;
